import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'alarms-summary',
  templateUrl: './alarms-summary.component.html',
  styleUrls: ['./alarms-summary.component.scss']
})
export class AlarmsSummaryComponent implements OnInit {

  @Input() selection: any;
  @Input() type: any;

  constructor() { }

  ngOnInit(): void {
  }

}
